var enNlTranslation = {
    "contact_us.buttonText": "Help",
    "contact_us.error.email": "Please enter a valid email",
    "contact_us.error.general": "Oops... Something went wrong. Please try again.",
    "contact_us.error.minimum_two_chars": "Should be at least 2 chars long",
    "contact_us.placeholders.email": "Email Address",
    "contact_us.placeholders.name": "Full Name",
    "contact_us.placeholders.text": "How can we help?",
    "contact_us.send": "Send",
    "contact_us.subtitle": "Fill in your details, write your question, and we will get back to you",
    "contact_us.success.ok": "Ok",
    "contact_us.success.subtitle": "We got your message and will get back to you as soon as possible.",
    "contact_us.success.title": "Thanks {{name}}!",
    "contact_us.title": "Ask Us Anything",
    "cookie_consent.customize.categories.essential.description": "",
    "cookie_consent.customize.categories.essential.title": "",
    "cookie_consent.customize.categories.performance.description": "",
    "cookie_consent.customize.categories.performance.title": "",
    "cookie_consent.customize.confirm_btn_title": "",
    "cookie_consent.customize.title": "",
    "cookie_consent.information.accept_btn_title": "",
    "cookie_consent.information.cookies_policy_link_text": "",
    "cookie_consent.information.customize_btn_title": "",
    "cookie_consent.information.description": "",
    "cookie_consent.information.title": "",
    "cxai.browser_toast": "For an optimal chat experience we recommend\nChrome, Safari, or Edge browsers",
    "cxai.default_description": "Personal Insurance Assistant",
    "cxai.error.message": "Something went wrong...",
    "cxai.error.retry": "RETRY",
    "cxai.phone_input.mobile_title": "",
    "cxai.phone_input.no_results": "",
    "cxai.phone_input.placeholder": "",
    "cxai.restart.action": "",
    "cxai.restart.close": "",
    "cxai.restart.content": "",
    "cxai.restart.title": "",
    "error_page.action": "Take me home",
    "error_page.subtitle": "Couldn't find the page you were looking for.",
    "error_page.title": "Oops.",
    "footer.disclaimer": "Please Note: These definitions don’t alter the terms, conditions, exclusions, or limitations of policies issued by Lemonade. They are intended for educational purposes only - they’re not meant to be used in lieu of professional legal or financial advice. We’ll do our best to keep them updated, but they may not always reflect current industry developments. Feel free to use the terms with attribution (friends don’t let friends plagiarize!).\n \nLemonade Insurance N.V. is a non-life insurer with a license from De Nederlandsche Bank (DNB) with reference number R162036. Lemonade Insurance N.V. is registered with the Netherlands Authority for the Financial Markets (AFM) under number 12047353 and registered with the Chamber of Commerce under number 73227420.\n \nLemonade Insurance N.V. has appointed Lemonade Agency B.V. as its authorized agent for the distribution of its insurance products. Lemonade Agency B.V. is registered with the AFM under number 12047085 and registered with the Chamber of Commerce under number 75134454.",
    "footer.titles.company": "company",
    "footer.titles.features": "features",
    "footer.titles.get_app": "download our app",
    "footer.titles.products": "",
    "footer.titles.resources": "resources",
    "footer.titles.social": "follow us",
    "footer.titles.contact": "contact us",
    "header.actions.login": "My Account",
    "header.actions.logout": "Logout",
    "header.actions.settings": "Settings",
    "header.accessibility.title": "",
    "header.api.title": "",
    "header.blank.title": "",
    "header.blog.title": "Blog",
    "header.car.title": "",
    "header.car_explained.title": "",
    "header.claims.title": "Claims",
    "header.community.title": "",
    "header.covid_19.title": "",
    "header.expats_de.title": "",
    "header.expats_nl.title": "Blog for Expats",
    "header.faq.title": "FAQ",
    "header.giveback.title": "Giveback",
    "header.giveback_2021.title": "Giveback",
    "header.global_expansion.title": "Where We're Live",
    "header.home.title": "Home",
    "header.homeowners.title": "",
    "header.imprint.title": "Imprint",
    "header.insurance_card.title": "Insurance Cards",
    "header.insuropedia.title": "Insurance Dictionary",
    "header.investors.title": "",
    "header.legal_stuff.title": "Legal Stuff",
    "header.life.title": "",
    "header.makers.title": "Join the Team",
    "header.manage_cookies.title": "",
    "header.partners_program.title": "",
    "header.personal_liability_hub.title": "",
    "header.pet.title": "",
    "header.pet_dog_insurance_explained.title": "",
    "header.pet_insurance.title": "",
    "header.policy_two.title": "Policy 2.0",
    "header.privacy_policy.title": "Privacy Policy",
    "header.renters.title": "",
    "header.renters_hub.title": "",
    "header.reviews.title": "",
    "header.sitemap.title": "",
    "header.term_life.title": "",
    "header.terms_of_service.title": "Terms of Service",
    "header.transparency.title": "",
    "nav.accessibility.title": "",
    "nav.api.title": "",
    "nav.blank.title": "",
    "nav.blog.title": "Blog",
    "nav.car.title": "",
    "nav.blog_en_nl_content_insurance.title": "Content Insurance",
    "nav.blog_en_nl_liability_insurance.title": "Liability Insurance",
    "nav.car_explained.title": "",
    "nav.claims.title": "Claims",
    "nav.community.title": "",
    "nav.global_partners_program.title": "Partners Program",
    "nav.covid_19.title": "",
    "nav.expats_de.title": "",
    "nav.expats_nl.title": "Blog",
    "nav.faq.title": "FAQ",
    "nav.giveback.title": "Giveback",
    "nav.giveback_2021.title": "Giveback",
    "nav.global_expansion.title": "Where We're Live",
    "nav.home.title": "Home",
    "nav.homeowners.title": "",
    "nav.imprint.title": "Imprint",
    "nav.insurance_card.title": "Insurance Cards",
    "nav.insuropedia.title": "Insurance Dictionary",
    "nav.investors.title": "",
    "nav.legal_stuff.title": "Legal Stuff",
    "language.select.label": "Select your language",
    "nav.life.title": "",
    "nav.makers.title": "Join the Team",
    "nav.manage_cookies.title": "",
    "nav.partners_program.title": "",
    "nav.personal_liability_hub.title": "",
    "nav.pet.title": "",
    "nav.pet_dog_insurance_explained.title": "",
    "nav.pet_insurance.title": "",
    "nav.policy_two.title": "Policy 2.0",
    "nav.privacy_policy.title": "Privacy Policy",
    "nav.renters.title": "",
    "nav.renters_hub.title": "",
    "nav.reviews.title": "",
    "nav.sitemap.title": "",
    "nav.term_life.title": "",
    "nav.terms_of_service.title": "Terms of Service",
    "nav.transparency.title": "",
    "privacy_banner.content": "We use cookies and other technologies to give you the best possible user experience and to customize advertising on and off our website. In addition, our partners may use cookies and other technologies to provide you with marketing information. Read more about this and your right to opt-out in our [Privacy Policy](privacyPolicyLink).",
    "privacy_banner.cta": "accept all",
    "nav.do_not_share_my_personal_information.title": "Do not share my personal information",
    "cookie_consent.customize.personalInfo.block3.description": "If you have an account with us and want to change, or delete your data, email us at privacy@lemonade.com or call us toll-free at 844-733-8666",
    "cookie_consent.customize.personalInfo.block1.description": "We use information collected through cookies to give you the best experiences we can. But, no worries, you can opt out from them at any time. As a California resident you have rights around the sale of personal information.",
    "cookie_consent.customize.personalInfo.block1.title": "Do not share my personal information"
};

export { enNlTranslation as default };
